<template>
    <form ref="contactEditForm">
        <b-row v-if="isDataLoaded">
            <b-col lg="4">
                <div class="form-group row">
                    <label for="salutation" class="col-4 col-form-label"
                        >Salutation:</label
                    >
                    <div class="col-8">
                        <input
                            id="salutation"
                            v-model="contact.salutation"
                            type="text"
                            class="form-control"
                            name="salutation"
                            placeholder="Salutation (optional)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="firstname" class="col-4 col-form-label"
                        >First Name:</label
                    >
                    <div class="col-8">
                        <input
                            id="firstname"
                            v-model="contact.firstname"
                            :class="{
                                'border-danger': errors.has('firstname')
                            }"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="firstname"
                            placeholder="First Name (required)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="lastname" class="col-4 col-form-label"
                        >Last Name:</label
                    >
                    <div class="col-8">
                        <input
                            id="lastname"
                            v-model="contact.lastname"
                            :class="{ 'border-danger': errors.has('lastname') }"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            placeholder="Last Name (required)"
                            name="lastname"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="title" class="col-4 col-form-label"
                        >Title:</label
                    >
                    <div class="col-8">
                        <input
                            id="title"
                            v-model="contact.title"
                            type="text"
                            class="form-control"
                            placeholder="Title (optional)"
                            name="title"
                        />
                    </div>
                </div>
            </b-col>
            <b-col lg="4">
                <div class="form-group row">
                    <label for="address" class="col-4 col-form-label"
                        >Address:</label
                    >
                    <div class="col-8">
                        <div v-if="useGoogleLocation">
                            <v-address-picker
                                id="address"
                                v-model="contact.address"
                                module="address"
                                class="form-control"
                                placeholder="Address (optional)"
                                name="address"
                            />
                        </div>
                        <div v-else>
                            <v-address-picker-aws
                                id="address"
                                v-model="contact.address"
                                module="address"
                                placeholder="Address (optional)"
                                name="address"
                                autocomplete="off"
                            />
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="zipcode" class="col-4 col-form-label"
                        >Zipcode:</label
                    >
                    <div class="col-8">
                        <div v-if="useGoogleLocation">
                            <v-address-picker
                                id="zipcode"
                                v-model="contact.zipcode"
                                module="zipcode"
                                name="zipcode"
                                class="form-control"
                                placeholder="Zipcode (optional)"
                            />
                        </div>
                        <div v-else>
                            <input
                                id="zipcode"
                                v-model="contact.zipcode"
                                module="zipcode"
                                name="zipcode"
                                placeholder="Zipcode (optional)"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="city" class="col-4 col-form-label">City:</label>
                    <div class="col-8">
                        <div v-if="useGoogleLocation">
                            <v-address-picker
                                id="city"
                                v-model="contact.city"
                                module="city"
                                class="form-control"
                                placeholder="City (optional)"
                            />
                        </div>
                        <div v-else>
                            <input
                                id="city"
                                v-model="contact.city"
                                module="city"
                                name="city"
                                placeholder="City (optional)"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="county" class="col-4 col-form-label"
                        >County:</label
                    >
                    <div class="col-8">
                        <div v-if="useGoogleLocation">
                            <v-address-picker
                                id="county"
                                v-model="contact.county"
                                module="county"
                                name="county"
                                class="form-control"
                                placeholder="County (optional)"
                            />
                        </div>
                        <div v-else>
                            <input
                                id="county"
                                v-model="contact.county"
                                module="county"
                                name="county"
                                placeholder="County (optional)"
                                class="form-control readonly-disabled"
                                readonly
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="state" class="col-4 col-form-label"
                        >State:</label
                    >
                    <div class="col-8">
                        <div v-if="useGoogleLocation">
                            <v-address-picker
                                id="state"
                                v-model="contact.state"
                                module="state"
                                name="state"
                                class="form-control"
                                placeholder="State (optional)"
                            />
                        </div>
                        <div v-else>
                            <input
                                id="state"
                                v-model="contact.state"
                                module="state"
                                name="state"
                                placeholder="State (optional)"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="country" class="col-4 col-form-label"
                        >Country:</label
                    >
                    <div class="col-8">
                        <div v-if="useGoogleLocation">
                            <v-address-picker
                                id="country"
                                v-model="contact.country"
                                module="country"
                                name="country"
                                class="form-control"
                                placeholder="Country (optional)"
                            />
                        </div>
                        <div v-else>
                            <input
                                id="country"
                                v-model="contact.country"
                                module="country"
                                name="country"
                                placeholder="Country (optional)"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col lg="4">
                <div class="form-group row">
                    <label for="work" class="col-4 col-form-label"
                        >Phone:</label
                    >
                    <div class="col-8">
                        <div class="row px-3">
                            <div class="col-5 pl-0">
                                <CountryCode
                                    v-model="contact.work_country_code"
                                    :defaultValue="$root.setting.phone_code"
                                    class="form-control"
                                    name="work_country_code"
                                />
                            </div>
                            <div class="col-7 px-0">
                                <input
                                    id="work"
                                    v-model="contact.work"
                                    v-validate="'international_phone'"
                                    :class="{
                                        'border-danger': errors.has('work')
                                    }"
                                    type="text"
                                    class="form-control"
                                    name="work"
                                    placeholder="Office Phone (optional)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="mobile" class="col-4 col-form-label"
                        >Mobile:</label
                    >
                    <div class="col-8">
                        <div class="row px-3">
                            <div class="col-5 pl-0">
                                <CountryCode
                                    :defaultValue="$root.setting.phone_code"
                                    v-model="contact.mobile_country_code"
                                    v-validate="'international_phone'"
                                    class="form-control"
                                    name="mobile_country_code"
                                />
                            </div>
                            <div class="col-7 px-0">
                                <input
                                    id="mobile"
                                    v-model="contact.mobile"
                                    v-validate="'international_phone'"
                                    :class="{
                                        'border-danger': errors.has('mobile')
                                    }"
                                    type="text"
                                    class="form-control"
                                    name="mobile"
                                    placeholder="Mobile Phone (optional)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="fax" class="col-4 col-form-label">Fax:</label>
                    <div class="col-8">
                        <div class="row px-3">
                            <div class="col-5 pl-0">
                                <CountryCode
                                    :defaultValue="$root.setting.phone_code"
                                    v-model="contact.fax_country_code"
                                    class="form-control"
                                    name="fax_country_code"
                                />
                            </div>
                            <div class="col-7 px-0">
                                <input
                                    id="fax"
                                    v-model="contact.fax"
                                    v-validate="'international_phone'"
                                    :class="{
                                        'border-danger': errors.has('fax')
                                    }"
                                    type="text"
                                    class="form-control"
                                    name="fax"
                                    placeholder="Fax (optional)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="email" class="col-4 col-form-label"
                        >Email:</label
                    >
                    <div class="col-8">
                        <input
                            id="email"
                            v-model="contact.email"
                            :class="{ 'border-danger': errors.has('email') }"
                            v-validate="'email'"
                            type="email"
                            class="form-control"
                            name="email"
                            placeholder="Email (optional)"
                        />
                    </div>
                </div>
            </b-col>
        </b-row>
    </form>
</template>
<script>
import { isEmpty } from "lodash";
import CountryCode from "@/module/commons/countrycode.vue";
import vAddressPicker from "@/module/commons/vet-address.vue";
import vAddressPickerAws from "@/module/commons/vet-address-aws.vue";

export default {
    components: {
        CountryCode,
        vAddressPicker,
        vAddressPickerAws
    },
    data() {
        return {
            useGoogleLocation: true
        };
    },
    computed: {
        isDataLoaded() {
            return !isEmpty(this.$store.state.contact.contactEditDetails);
        },
        contactId() {
            return this.$store.state.contact.contactId;
        },
        contact() {
            return this.$store.state.contact.contactEditDetails;
        }
    },
    watch: {
        "contact.firstname"() {
            this.validate();
        },
        "contact.lastname"() {
            this.validate();
        },
        "contact.email"() {
            this.validate();
        }
    },
    mounted() {
        this.addressPicked();
        this.useGoogleLocation = process.env.USE_GOOGLE_LOCATION === "true";
    },
    methods: {
        addressPicked() {
            let self = this;
            self.$root.$on("addressPicked", address => {
                if (_.isObject(address) && !_.isUndefined(address.address)) {
                    self.contact.zipcode = address.zipcode;
                    self.contact.city = address.city;
                    self.contact.county = address.county;
                    self.contact.state = address.state;
                    self.contact.country = address.country;
                }
            });
        },
        async validate() {
            let valid = await this.$validator.validateAll();
            if (!valid) {
                this.$store.commit("contact/setIsValidated", false);
            } else {
                this.$store.commit("contact/setIsValidated", true);
            }
        }
    }
};
</script>
<style type="text/css" scoped>
.readonly-disabled {
    background-color: #e9ecef;
    opacity: 1;
    cursor: not-allowed;
}
</style>
